<template>
  <div class="blog-list mt-5">
    <app-loading :isFull="true" v-if="isLoading" />

    <div class="container">
      <div class="row">
        <div class="container-fluid">
          <div class="col-12">
            <header class="mb-3">
              <h2 class="font-18 text-right">لیست مقالات</h2>
            </header>
            <div class="shadow shadow-sm mb-5 bg-white">
              <b-table
                stacked="lg"
                striped
                :fields="fieldsItems"
                :items="posts"
                class="text-center"
              >
                <template v-slot:cell(title)="data">
                  <router-link :to="`/dashboard/blog/edit/${data.item.id}`" class="text-truncate sw-140">
                    {{data.item.title}}
                  </router-link>
                </template>

                <template v-slot:cell(pub_date)="data" >
                  {{data.item.pub_date | date}}
                </template>
                <template v-slot:cell(status)="data">
                  <!-- <i class="flaticon-content text-success font-12" v-if="data.item.status === 'edit'"></i> -->
                  {{listStatus[data.item.status]}}
                     <!-- <div class="input-checkbox rtl text-right">
                        <div class="md-checkbox">
                            <input type="checkbox" id="edit" v-model="data.item.status">
                            <label for="edit" class="font-14"></label>
                        </div>
                    </div> -->
                </template>
                <template v-slot:cell(action)="data" >
                  <div class="text-center">
                       <span data-balloon-pos="up" data-balloon="حذف مقاله">
                      <button
                        class="bttn-material-circle bttn-jelly bttn-md bttn-danger text-center"
                        v-ripple
                        @click.stop="remove(data)"
                      >
                        <i class="flaticon-dustbin"></i>
                      </button>

                    </span>
                    <span data-balloon-pos="up" data-balloon="غیر فعال کردن">
                      <button
                        class="bttn-material-circle bttn-jelly bttn-md bttn-gray text-center"
                        v-ripple
                        @click.stop="inactive(data)"
                      >
                        <i class="flaticon-dustbin"></i>
                      </button>

                    </span>

                     <span data-balloon-pos="up" data-balloon="صدور انتشار" class="mx-2">
                       <button
                        class="bttn-material-circle bttn-jelly bttn-md bttn-success text-center"
                        v-ripple
                        @click.stop="publish({item:data.item,index:data.index,newStatus:'publish'})"
                      >
                        <i class="flaticon-content"></i>
                      </button>
                       </span>
                         <span data-balloon-pos="up" data-balloon="اخذ انتشار">
                       <button
                        class="bttn-material-circle bttn-jelly bttn-md bttn-gray text-center"
                        v-ripple
                        @click.stop="publish({item:data.item,index:data.index,newStatus:'reject'})"
                      >
                        <i class="flaticon-content"></i>
                      </button>
                       </span>
                  </div>
                </template>
              </b-table>
            </div>
            <page-number :lengthList="lengthList" @callBack="callBack"/>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "blog-list",
  data() {
    return {
      lengthList: 15,
      isLoading:true,
      page: 1,
      fieldsItems: [
        { key: "fullname", label: "نویسنده" },
        { key: "title", label: "عنوان" },
        { key: "pub_date", label: "تاریخ ساخت" },
        { key: "status", label: "وضعیت" },
        { key: "action", label: "عملیات" }
      ],
      listStatus:{
        pending:'در انتظار بررسی',
        publish:'منتشر شده',
        reject:'رد شده',
        edit:'ویرایش شده',
        deactivate:'غیر فعال',
      }
    };
  },
  computed: {
    posts() {
      return this.$store.state.dashboardBlog.allPosts;
    }
  },
  mounted() {
    this.getPosts(1);
  },
  methods: {
    async callBack(p) {
      this.isLoading = true;
      this.page = p;
      let res = await this.$store.dispatch("dashboardBlog/getAllPosts", {
        page: this.page
      });
      this.lengthList = res.posts.length;
      this.isLoading = false;
    },
    async publish({ item, index , newStatus}) {
       let res =  await this.$store.dispatch("dashboardBlog/setStatus", {
          id: item.id,
          status:newStatus
        });
        console.log(res);
        console.log(item.status);
       if(res){
            this.$set(this.posts[index], 'status', newStatus)
       }

      // if (item.status === "publish") {
      // } else if(item.status === "pending") {
      // }else if(item.status === "edit") {
      // }
    },
    async getPosts(page) {
      this.isLoading = true;
      await this.$store.dispatch("dashboardBlog/getAllPosts", { page });
      this.isLoading = false;
    },
    async inactive({ item, index }) {
      let result = window.confirm("آیا از غیر فعال کردنه این مقاله مطمئن هستید؟");
      if (!result) return;
      this.isLoading = true;
      let res =  await this.$store.dispatch("dashboardBlog/setStatus", {
          id: item.id,
          status: 'deactivate'
      });
      // this.$delete(this.posts, index);
      this.$set(this.posts[index], 'status', 'deactivate')
      this.isLoading = false;
    },
    async remove({ item, index }) {
      let result = window.confirm("آیا از حذف کردنه این مقاله مطمئن هستید؟");
      if (!result) return;
      this.isLoading = true;
      let res =  await this.$store.dispatch("dashboardBlog/remove", {
          id: item.id
      });
      // this.$delete(this.posts, index);
      this.$set(this.posts[index], 'status', 'deactivate')
      this.isLoading = false;
    },
    async edit({ item, index }) {
      this.$router.push(`/dashboard/blog/edit/${item.id}`);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/dashboard/blog/manage.vue